import axios from '../request/http.js'

class Canteen {
  /* 食堂列表 */
  static getCanteenList(currentPage) {
    let url = `/zzd/api/back/canteen/page?currentPage=${currentPage}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 食堂列表不分页 */
  static getCanteenNoPageList() {
    let url = `/zzd/api/back/canteen/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除食堂 */
  static postDelCanteen(data) {
    let url = `/zzd/api/back/canteen/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增食堂 */
  static postAddCanteen(data) {
    let url = `/zzd/api/back/canteen/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑食堂 */
  static postModCanteen(data) {
    let url = `/zzd/api/back/canteen/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 编辑食堂服务范围 */
  static postModCanteenRange(data) {
    let url = `/zzd/api/back/canteen/update/service/scope`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 获取编辑详情 */
  static getDetails(id) {
    let url = `/zzd/api/back/canteen/detail?id=${id}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 导入菜单 */
  static postUploadFoodMenu(data) {
    let url = `/zzd/api/back/menu/upload/template`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Canteen